import React from 'react';
import cs from 'classnames';

import LabeledInput from '~/components/common/LabeledInput';

import css from './index.css';

class lengthInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleBlur = this.handleBlur.bind(this);
    this.state = {
      touched: false
    }
  }
  render() {
    return (
      <div className={cs({[css.wrap]:!this.props.input.wrapClassName}, 'qa-weight-input')}>
        <LabeledInput
          {...this.props.input}
          label='Max Length (ft)'
          type='number'
          value={this.props.value}
          touched={this.props.touched || this.state.touched}
          error={this.props.error}
          onChange={this.props.onChange}
          onBlur={this.handleBlur}
        />
      </div>
    )
  }
  handleBlur() {
    this.setState({
      touched: true
    })
  }
}

export default lengthInput;



// WEBPACK FOOTER //
// ./src/components/common/LengthInput/index.js